@if ((visible$ | async) || (productType$ | async) === 'RetailSet') {
<div class="product-availability">
  @if (available$ | async) {
  <span class="product-in-stock">
    {{ 'product.stock.availablity.title' | translate }}
    <span class="product-stock-availablity">{{ 'product.instock.text' | translate }} </span>
    @if (availableStock$ | async; as stock) {
    <ng-container class="availableStock">({{ stock }})</ng-container>
    }
    <link itemprop="availability" href="http://schema.org/InStock" />
  </span>
  } @else {
  <span class="product-out-of-stock">
    {{ 'product.stock.availablity.title' | translate }}
    <span class="product-stock-availablity">{{ 'product.out_of_stock.text' | translate }} </span>
    <link itemprop="availability" href="http://schema.org/OutOfStock" />
  </span>
  }
</div>
}
